import React from 'react'
import "./Signup.css"
import logoImage from "../../images/WhatsAppBulkSend.svg";

function Signup() {
  return (
    <div className='whatsappbulksend-signup-Signup'>
      <div className="whatsappbulksend-signup-container">

        <div className="whatsappbulksend-signup-triangle whatsappbulksend-signup-triangle-dark whatsappbulksend-signup-triangle1"></div>
        <div className="whatsappbulksend-signup-triangle whatsappbulksend-signup-triangle-dark whatsappbulksend-signup-triangle2"></div>
        <div className="whatsappbulksend-signup-triangle whatsappbulksend-signup-triangle-dark whatsappbulksend-signup-triangle3"></div>

        <div className="whatsappbulksend-signup-triangle whatsappbulksend-signup-triangle-light whatsappbulksend-signup-triangle4"></div>
        <div className="whatsappbulksend-signup-triangle whatsappbulksend-signup-triangle-light whatsappbulksend-signup-triangle5"></div>
        <div className="whatsappbulksend-signup-triangle whatsappbulksend-signup-triangle-light whatsappbulksend-signup-triangle6"></div>

        <img className='whatsappbulksend-signup-logo-placeholder' src={logoImage} alt="" />
        <p className='whatsappbulksend-signup-heading'>Create Your Account</p>

        <form>
          <div className="whatsappbulksend-signup-form-group">
            <label htmlFor="name">Full Name</label>
            <input type="text" id="name" name="name" required />
          </div>

          <div className="whatsappbulksend-signup-form-group">
            <label htmlFor="email">Work Email</label>
            <input type="email" id="email" name="email" required />
          </div>

          <div className="whatsappbulksend-signup-form-group">
            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" required />
          </div>

          <div className="whatsappbulksend-signup-form-group">
            <label htmlFor="company">Company Name</label>
            <input type="text" id="company" name="company" required />
          </div>

          <div className="whatsappbulksend-signup-form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required />
          </div>

          <button type="submit" className="whatsappbulksend-signup-button">Sign Up</button>

          <p className="whatsappbulksend-signup-login-link">
            Already have an account? <a href="/login">Log in</a>
          </p>
        </form>
      </div>
    </div>
  )
}

export default Signup;
